<template>
  <div>
    {{ content.text }}
    <div class='col-sm-12 col-center-block'>
      <el-button v-for="(reply, key) in content.quick_replies" :key="key" size='small' @click="sendCommand(reply.payload)">{{ reply.title }}</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'QuickReplyMessage',
  props: {
    message: {
      type: Object,
      required: true
    }
  },
  computed: {
    content () {
      return JSON.parse(this.message.content)
    }
  },
  methods: {
    sendCommand (payload) {
      this.$emit('send-action', payload)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/sections/chat/QuickReplyMessage.vue